// Сгенерировано из радарной схемы Dust II: контур проходимой зоны и маршруты, проложенные по нему.
// viewBox 0 0 400 400. Маршрут: [время, x, y].
export const mapPath =
  "M30 7L29 72L25 73L25 81L27 82L27 84L23 84L23 104L26 104L25 129L37 130L37 163L25 163L25 197L42 197L43 196L45 196L47 197L54 197L54 203L65 203L65 225L49 225L48 234L36 234L35 263L37 296L34 297L34 331L21 345L21 381L58 381L59 384L122 384L134 383L189 383L190 393L236 393L236 378L259 378L259 344L253 343L253 323L266 322L267 325L288 325L287 300L287 265L285 265L283 262L283 261L287 260L287 223L283 223L283 220L286 218L297 220L303 225L302 271L330 271L331 274L359 274L360 262L377 262L377 197L360 195L362 140L367 130L371 129L372 125L379 125L379 113L377 85L363 85L363 41L360 41L360 15L309 15L308 41L241 41L241 46L244 47L243 62L240 62L239 61L223 61L223 76L217 82L214 83L196 84L190 83L190 59L125 59L125 48L124 47L111 47L100 48L98 41L84 32L52 32L52 8ZM191 263L224 263L229 268L229 310L227 310L227 324L221 330L214 330L213 327L193 327L187 321L185 301L185 268ZM173 167L173 188L171 189L170 194L170 210L173 211L173 223L162 224L162 242L153 242L153 245L158 271L173 272L173 344L172 344L134 344L134 302L117 302L116 310L100 310L95 305L95 291L100 286L108 285L109 273L104 243L104 234L95 233L95 225L77 225L77 203L82 203L82 197L101 197L104 196L106 197L112 197L120 196L124 192L127 188L129 182L129 172L170 172L170 168ZM328 110L328 180L305 180L303 187L299 187L297 191L292 191L282 191L282 180L265 183L262 185L262 218L268 220L268 223L265 223L264 226L264 260L268 261L267 264L260 265L261 245L213 245L208 240L208 176L213 171L234 171L264 169L264 107L297 107L298 110ZM244 103L244 118L240 119L240 152L225 152L225 146L207 146L206 152L190 152L190 136L196 135L196 129L191 128L191 113L218 113L228 107L239 107L240 103ZM49 130L65 129L65 146L77 146L82 137L97 120L98 104L100 104L101 101L103 101L104 104L108 104L109 107L127 107L127 104L141 104L142 107L152 107L153 104L166 104L166 142L173 143L173 156L170 156L169 151L110 152L110 171L116 172L116 174L105 174L103 175L72 174L71 163L49 163ZM100 55L103 55L103 84L100 84Z";

export const routes: Record<string, [number, number, number][]> = {
  t1: [
    [0, 172, 356], [0.6, 172, 356], [3.03, 240, 321], [5.51, 275, 251], [6.87, 283, 209],
    [9.0, 350, 206], [10.4, 350, 198],
  ],
  t2: [
    [0, 160, 362], [1.4, 160, 362], [4.19, 240, 321], [6.61, 275, 251], [7.94, 283, 209],
    [10.2, 350, 238], [10.8, 350, 238], [11.8, 350, 176], [13.8, 350, 128],
  ],
  t3: [
    [0, 150, 358], [2.2, 150, 358], [5.04, 239, 324], [7.5, 275, 250], [8.78, 284, 208],
    [11.2, 350, 255], [13.0, 350, 200], [14.4, 348, 140], [15.2, 346, 120], [16.4, 326, 84],
    [19.4, 326, 84], [20.6, 342, 58], [32.3, 342, 58], [35.0, 352, 152],
  ],
  t4: [
    [0, 138, 352], [1.0, 138, 352], [2.56, 181, 343], [6.14, 184, 242], [8.0, 190, 190],
    [9.0, 190, 190], [10.46, 219, 161], [11.72, 252, 148], [13.0, 254, 112], [15.0, 286, 72],
    [16.0, 290, 52], [21.2, 290, 52],
  ],
  t5: [
    [0, 152, 356], [1.8, 152, 356], [3.05, 181, 340], [8.8, 186, 188], [9.8, 186, 188],
    [11.36, 223, 161], [12.46, 252, 147], [13.6, 256, 114], [15.32, 280, 88], [15.8, 290, 88],
    [16.8, 290, 102], [24.6, 290, 102],
  ],
  ct1: [
    [0, 232, 90], [0.6, 232, 90], [4.19, 346, 114], [5.3, 350, 150], [11.8, 350, 150],
  ],
  ct2: [
    [0, 222, 98], [1.0, 222, 98], [5.0, 345, 98], [15.2, 345, 98],
  ],
  ct3: [
    [0, 170, 78], [0.9, 170, 78], [4.05, 97, 51], [5.0, 74, 46], [12.5, 74, 46], [13.71, 109, 55],
    [17.75, 223, 94], [19.2, 266, 90], [19.8, 270, 90], [22.8, 270, 90],
  ],
  ct4: [
    [0, 178, 92], [1.6, 178, 92], [4.71, 91, 84], [5.5, 92, 62], [13.2, 92, 62], [14.07, 101, 91],
    [18.4, 252, 95], [22.8, 252, 95], [23.8, 272, 93], [25.4, 284, 88], [26.2, 286, 88],
  ],
  ct5: [
    [0, 190, 100], [2.0, 190, 100], [6.0, 60, 92], [14.2, 60, 92], [20.9, 240, 94],
    [26.2, 240, 94], [27.9, 306, 78], [30.4, 306, 78],
  ],
};
